import { useEffect, useState } from 'react'

import { FormattedMessage } from 'react-intl'
import { Collapse } from '@mui/material'
import Panel from '../../../ui/Panel/Panel'
import Table from '../../../components/Table/Table'

import {
  IUsersReferenceStepOneProps,
  TypeFilter,
  USER_REFERENCE_FORM_FILTER,
} from './module/constants'
import messages from './module/messages'
import filterMessages from '../../../translations/filterMessages'
import { USER_REFERENCE_URLS } from '../module/constants'

import {
  selectFilterForm,
  selectUsers,
  selectUsersLoader,
} from '../module/selectors'
import {
  modifySelectedUser,
  usersRequest,
  userResetState,
} from '../module/actions'

import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FilterTable from '../../../components/FilterTable/FilterTable'

import { isEmpty } from 'ramda'
import { push } from 'connected-react-router'
import OutlinedButton from '../../../ui/OutlinedButton/OutlinedButton'

import classes from './UsersReferencenStepOne.module.scss'
import {
  IDENTITY_SYSTEM_LIST,
  IdentitySystemType,
  ROUTES,
} from '../../../module/constants'
import {
  ISectionType,
  ITableType,
} from '../../../common/TablesConfiguration/tcConstants'
import { convertStoredFilterToState } from '../../../utils/utils'
const form = USER_REFERENCE_FORM_FILTER

const UsersReferencenStepOne = (props: IUsersReferenceStepOneProps) => {
  const {
    users,
    usersLoader,
    filterValues,
    modifySelectedUser,
    usersRequest,
    resetState,
    goBack,
  } = props

  const [filter, setFilter] = useState<any>(
    filterValues && filterValues.values
      ? convertStoredFilterToState(filterValues)
      : ([] as any[])
  )

  const onSubmit: any = (values: any = {}) => {
    const { advancedSearchFilter, allFilter = '', ...rest } = values
    let valueFilter: any[] = []
    if (values && isEmpty(values)) return setFilter([])

    if (advancedSearchFilter) {
      if (!isEmpty(rest)) {
        Object.keys(rest).forEach((element: any) => {
          valueFilter.push({
            id: TypeFilter[element as keyof typeof TypeFilter],
            value:
              element === 'identitySystemIdFilter'
                ? IdentitySystemType[rest[element]]
                : rest[element],
            operation: 'AND',
          })
        })
      }
    } else {
      valueFilter = [
        { id: 'id', value: allFilter, operation: 'OR' },
        { id: 'name', value: allFilter, operation: 'OR' },
        { id: 'surname', value: allFilter, operation: 'OR' },
      ]
    }
    setFilter(valueFilter)
  }

  useEffect(() => {
    resetState()
    usersRequest()
  }, [resetState, usersRequest])

  return (
    <div>
      <div className={classes['cta_wrapper']}>
        <OutlinedButton onClick={goBack}>
          <FormattedMessage {...messages.CTA_BACK} />
        </OutlinedButton>
      </div>
      <Collapse in={true}>
        <Panel
          title={<FormattedMessage {...messages.PanelTitle} />}
          loader={usersLoader}
        >
          {users && users.length === 0 ? (
            <div className={classes['text-no-users']}>
              <FormattedMessage {...messages.noUserFound} />
            </div>
          ) : (
            <></>
          )}
          {users && users.length > 0 ? (
            <>
              <FilterTable
                messages={{ ...filterMessages, ...messages }}
                formProps={form}
                listsFilter={{
                  IDENTITY_SYSTEM_LIST: {
                    list: IDENTITY_SYSTEM_LIST,
                    type: IdentitySystemType,
                  },
                }}
                onSubmitProps={(val: any) => {
                  onSubmit(val)
                }}
                advancedFilter={true}
                isAccordion={true}
                sectionType={ISectionType.EXAMINE_USERS}
                tableType={ITableType.USERS_TABLE}
                simpleFilterFields={['id', 'name', 'surname']}
                typeFilter={TypeFilter}
              />
              <Table
                filterProps={filter}
                dataSource={users}
                rowsChangeable={true}
                showDetail={true}
                onDetailClick={modifySelectedUser}
                detailURL={USER_REFERENCE_URLS.USER_DETAIL}
                tableName={'Users_list'}
                sectionType={ISectionType.EXAMINE_USERS}
                tableType={ITableType.USERS_TABLE}
              />
            </>
          ) : (
            <></>
          )}
        </Panel>
      </Collapse>
      <div className={classes['cta_wrapper_bottom']}>
        <OutlinedButton onClick={goBack}>
          <FormattedMessage {...messages.CTA_BACK} />
        </OutlinedButton>
      </div>
    </div>
  )
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    users: selectUsers,
    usersLoader: selectUsersLoader,
    filterValues: selectFilterForm,
  })

const mapDispatchToProps: any = {
  modifySelectedUser: (user: {}) => modifySelectedUser(user),
  usersRequest: () => usersRequest(),
  resetState: () => userResetState(),
  goBack: () => push(ROUTES.WELCOME),
}

const withConnect: any = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(UsersReferencenStepOne)
